import { fromJS } from 'immutable'
import { RxConversationAPI } from '@driftt/dapper'
import { parsePagedData } from 'utils/paging'
import { parseBotCampaign } from './models'
import { CampaignTypes } from './constants'

function parseCampaign(data) {
  if (data.type === CampaignTypes.BOT) {
    return parseBotCampaign(data)
  }

  return fromJS(data)
}

export const api = {
  fetch(id) {
    return RxConversationAPI.get(`/campaigns/${id}`)
      .checkStatus()
      .retryWithBackoff()
      .map(({ response }) => parseCampaign(response))
  },

  update(id, operations) {
    return RxConversationAPI.patch(`/campaigns/${id}/patch`, operations)
      .checkStatus()
      .retryWithBackoff()
      .map(({ response }) => parseCampaign(response))
  },

  search(query, { offset = 0, limit = 30 }) {
    return RxConversationAPI.get(`/campaigns`, { q: query, size: limit, ['from']: offset })
      .checkStatus()
      .retryWithBackoff()
      .map(parsePagedData())
  },
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/campaigns/api.js